import { FC, useEffect, useState } from "react";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useModelVehicleStore } from "../../hooks/useModelVehicleStore";
import { ModelVehicle } from "../../types/slices/modelVehicleType";
import { RoutesMap } from "../../types";
import { Divider, FormLabel, Grid, TextField } from "@mui/material";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";

type ModelVehiclesDataForm = {
    id: number
    name: string
    number_axles: number
    axle_detail: {}
}

export const ModelVehicleForm: FC = () => {
    const navigate = useNavigate();
    const { modelVehicleStatus, selectedModelVehicle, setSelectedModelVehicle, createModelVehicleStore, editModelVehicleStore } = useModelVehicleStore();

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [data, setData] = useState<ModelVehiclesDataForm>({
        id: 0,
        name: '',
        number_axles: 0,
        axle_detail: {}
    });

    useEffect(() => {
        if (Object.entries(selectedModelVehicle).length > 0) {
            setIsEdit(true);
            setData({
                id: selectedModelVehicle.id,
                name: selectedModelVehicle.name,
                number_axles: selectedModelVehicle.number_axles,
                axle_detail: selectedModelVehicle.axle_detail
            });
            setSelectedModelVehicle({} as ModelVehicle);
        }
    }, []);

    const onSubmit = async (values: any) => {
        const payload = {
            name: values.name,
            number_axles: values.number_axles
        }
        const method = !isEdit ? createModelVehicleStore(payload) : editModelVehicleStore(data.id, payload);
        const response = await method;
        if (response === true) {
            navigate({ pathname: RoutesMap.MODEL_VEHICLES })
        }
    }

    const onCancel = async () => {
        navigate({ pathname: RoutesMap.MODEL_VEHICLES });
    };

    const validateForm = (values: any) => {
        let errors: any = {};
        if (!values.name) errors.name = "El nombre del modelo de vehículo es obligatorio"
        return errors;
    }

    return (
        <CustomForm>
            {modelVehicleStatus === ApiStatus.FETCHING && (
                <CustomBackdrop open={true} />
            )}
            <CustomFormHeader
                title={!isEdit ? "Nuevo modelo de vehículo" : "Editar modelo de vehículo"}
                text={
                    !isEdit
                        ? "Ingrese los datos del nuevo modelo de vehículo"
                        : "Ingrese los datos del modelo de vehículo"
                }
                goBack={RoutesMap.MODEL_VEHICLES}
            />
            <CustomFormBody>

                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (<form onSubmit={handleSubmit}>
                            <Grid item container xs={12} spacing={2} marginBottom={2}>
                                <Grid item xs={12} md={4} marginLeft={2}>
                                    <FormLabel>Nombre:</FormLabel>
                                    <TextField
                                        id="name"
                                        type="text"
                                        name="name"
                                        inputProps={{
                                            maxLength: 45,
                                        }}
                                        fullWidth
                                        size="small"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={
                                            errors.name && touched.name
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            errors.name && touched.name
                                                ? errors.name
                                                : ""
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Divider />
                            <CustomFormFooter
                                buttonType="submit"
                                confirmText={
                                    !isEdit ? "Guardar" : "Actualizar"
                                }
                                cancelText={"Cancelar"}
                                onConfirm={handleSubmit}
                                onCancel={onCancel}
                            />
                        </form>)
                    }}
                </Formik>
            </CustomFormBody>
        </CustomForm>
    )
}
